import { ColorsTheme } from "./types";

export const colors: ColorsTheme = {
    purple: {
        primary: "#8868EA",
        secondary: "#B49EF9",
        tertiary: "#f3f0fd",
    },
    grey: {
        primary: "#8A8A8A",
        secondary: "#BDBDBD",
        tertiary: "#F9F9F9",
        tertiary2: "#ECECEC",
        dark: "#434343",
        text: "#CECBD2",
    },
    red: {
        primary: "#FF0D41",
    },
    green: {
        primary: "#3CB006",
    },
    background: "#F9F9F9",
    white: "#ffffff",
    black: "#111111",
    text: "#434343",
};
